export enum HallowABFlag {
  FamilyPlanOneClickUpgrade = "family_plan_upgrade",
  WebAccountCreationScreenABC = "web_account_creation_screen_abc",
  WebAdventShortOnboarding = "web_advent_short_onboarding",
  WebAppDownloadScreen = "web_app_download_screen",
  WebFamilyPlanUpgradeAdvent = "web_family_plan_one_click_upgrade_advent",
  WebHomepageCTADestination = "web_homepage_cta_destination",
  WebMediumOnboarding = "web_medium_onboarding",
  WebVariableTrialLength = "web_variable_trial_length",
  WebDOBCollection = "web_dob_collection",
  WebOnboardingSmsPrompt = "web_onboarding_sms_prompt",
  WebLentOnboarding = "web_lent_onboarding",
  WebFirstOnboardingScreen = "web_first_onboarding_screen",
  WebRoutines = "web_routines",
}
